import { render, staticRenderFns } from "./BAVideoJSPlayer.vue?vue&type=template&id=61123a7f&scoped=true&"
import script from "./BAVideoJSPlayer.vue?vue&type=script&lang=js&"
export * from "./BAVideoJSPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61123a7f",
  null
  
)

export default component.exports